var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-page"},[(this.$store.state.user.service_client.name=='SmartCoachPro')?[_c('proDashboard')]:_vm._l((this.$store.state.user.subscriptions),function(subscription,index){return _c('particularDashboard',{key:index,attrs:{"subscription":subscription,"ident":index}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }